module.exports = __webpack_public_path__ + "img/065.8e4c35be.jpg";